import { __decorate } from "tslib";
import { injectable } from 'mana-syringe';
let GraphMappingHelper = class GraphMappingHelper {
    constructor() {
        this.groupNodeMap = new Map();
        // node 的 mapping
        this.nodeMap = new Map();
        this.nodeMappingRecord = new Map();
        // port 的 mapping
        this.portMap = new Map();
        this.portMappingRecord = new Map();
        // edge 的 mapping
        this.edgeMap = new Map();
        this.edgeMappingRecord = new Map();
        // 区分类型
        this.getNodesByType = (nodes) => {
            return nodes.reduce((acc, node) => {
                if (node.isGroup) {
                    acc.groupNodes.push(node);
                }
                else {
                    acc.normalNodes.push(node);
                }
                return acc;
            }, { normalNodes: [], groupNodes: [] });
        };
        // 增加已有节点
        this.getNodePorts = (node) => {
            if (Array.isArray(node.ports)) {
                return node.ports;
            }
            if (node.ports && Array.isArray(node.ports.items)) {
                return node.ports.items;
            }
            return [];
        };
        // 增加已有节点
        this.addNodes = (nodes) => {
            nodes.forEach(node => {
                if (node.isGroup) {
                    this.groupNodeMap.set(node.id, node);
                }
                else {
                    const ports = this.getNodePorts(node);
                    this.nodeMap.set(node.id, node);
                    ports.forEach(port => {
                        this.portMap.set(port.id, port);
                    });
                }
            });
        };
        // 增加已有edge
        this.addEdge = (edges) => {
            edges.forEach(edge => {
                this.edgeMap.set(edge.id, edge);
            });
        };
        // 添加node的映射关系
        this.buildNodeMapping = (currentNode, nextNode) => {
            const currentNodeId = currentNode.id || currentNode.originId;
            const nextNodeId = nextNode.id;
            this.nodeMappingRecord.set(currentNodeId, nextNodeId);
            const ports = this.getNodePorts(currentNode);
            ports.forEach((oldPort, index) => {
                const newPort = nextNode.ports[index];
                if (newPort) {
                    this.portMap.set(newPort.id, newPort);
                    this.portMappingRecord.set(oldPort.id, newPort.id);
                }
            });
        };
        // 更新Edge的NodeId和PortId
        this.createEdgeBetweenNodes = (edgeConfig) => {
            const { source, sourcePortId, target, targetPortId } = edgeConfig;
            return Object.assign(Object.assign({}, edgeConfig), { source: this.nodeMappingRecord.get(source), target: this.nodeMappingRecord.get(target), sourcePortId: this.portMappingRecord.get(sourcePortId), targetPortId: this.portMappingRecord.get(targetPortId) });
        };
        // 更新GroupNode的NodeId
        this.buildGroupRelations = (groupNode) => {
            const { groupChildren } = groupNode;
            const newGroupChildren = groupChildren.map(id => {
                return this.nodeMappingRecord.get(id);
            });
            return Object.assign(Object.assign({}, groupNode), { groupChildren: newGroupChildren });
        };
    }
};
GraphMappingHelper = __decorate([
    injectable()
], GraphMappingHelper);
export { GraphMappingHelper };
//# sourceMappingURL=mapping-service.js.map